module.exports = __webpack_public_path__ + "img/slack.50c1a666.svg";